module.exports = __webpack_public_path__ + "static/html5-5b91de2a73a56b0c3f8f4cbba1ade3c7.png";